<template lang="pug">
div
	h1 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		v-card.pa-1.mb-6.text-center(outlined color="info")
			minimum-filter(:duration="filters.duration" :persons="filters.persons" :date="filters.date" @update="updateFilters" instant disable-action horizontal)
			nuxt-link(:to="localePath({name: 'accommodations-search', hash: `#${filterstring}`})") Zoek met uitgebreide filters
		accommodation-list(:filterstring="filterstring")
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import AccommodationList from '@dengl/common/components/accommodations/list.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import MinimumFilter from '@/components/accommodations/minimum-filter.vue';

const {
	encodeFilters,
	decodeFilters
} = require('@dengl/common/utils/filterstrings');

const resortAccommodations = gql`
	query resortAccommodations($slug: String!, $path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		resort(slug: $slug) {
			id
			name
			slug
			country {
				id
				name
				countryCode
				slug
			}
			region {
				id
				name
				slug
			}
			area {
				id
				name
				slug
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/dorpen/:resort/:accommodationtype',
			'de-DE': '/doerfer/:resort/:accommodationtype',
			'nl-BE': '/dorpen/:resort/:accommodationtype'
		}
	},
	components: {
		AccommodationList,
		MinimumFilter
	},
	validate({ params, app }) {
		const type = app.$normalizeSlug(params.accommodationtype);
		return [
			'accommodations',
			'apartments',
			'chalets',
			'hotels',
			'pensions'
		].includes(type);
	},
	// eslint-disable-next-line @milqmedia/milq/page-has-meta
	asyncData({ params, app, route }) {
		return app.$graphClient
			.query({
				query: resortAccommodations,
				variables: {
					slug: params.resort,
					path: route.path,
					fallback: route.path.replace(params.resort, '_resort')
				}
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(
						404,
						null,
						'resorts-resort-accommodations-01',
						errors
					);
				}
				if (errors) {
					throw errors[0];
				}

				app.interpolater(data.contentpage.meta, ['title', 'description']);
				app.interpolater(data.contentpage.content, ['markdown']);
				app.interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({});
				app.resortBreadcrumbs(data.resort, {
					[params.accommodationtype]: {
						name: 'resorts-resort-accommodationtype',
						params: {
							resort: data.resort.slug,
							accommodationtype: params.accommodationtype
						}
					}
				});

				data.filters = {
					date: '2024-02-17',
					persons: 2,
					duration: 7,
					types: [app.$normalizeSlug(params.accommodationtype).slice(0, -1)],
					resortslugs: [data.resort.slug]
				};

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(
					500,
					null,
					'resorts-resort-accommodations-02',
					error
				);
			});
	},
	data() {
		return {};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		filterstring() {
			return encodeFilters(this.filters, this.$i18n.locale);
		}
	},
	created() {
		this.$emit('update:showSidebar', false);
	},
	mounted() {
		if (this.$route.hash) {
			const filterstring = this.$route.hash.replace('#', '');
			this.updateFilters(decodeFilters(filterstring, this.$i18n.locale));
		}
	},
	methods: {
		updateFilters(filters) {
			for (const [filter, value] of Object.entries(filters)) {
				this.filters[filter] = value;
			}
		}
	}
};
</script>
